import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { ArticleSchema, BreadcrumbListSchema, WebPageSchema } from '@/components/feature/SchemaOrg';
import { latestArticles } from '@/mocks/homeData';

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [id]);

  const article = latestArticles.find((a) => a.id === Number(id)) || latestArticles[0];

  const relatedArticles = latestArticles.filter((a) => a.id !== article.id).slice(0, 3);

  return (
    <>
      <ArticleSchema
        title={article.title}
        description={article.summary}
        datePublished={article.date}
        imageUrl={article.image}
        url={`https://hongtaovideo.com/article/${article.id}`}
      />
      <WebPageSchema
        name={`${article.title} - 红桃视频`}
        description={article.summary}
        url={`https://hongtaovideo.com/article/${article.id}`}
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: 'https://hongtaovideo.com/' },
          { name: '资讯', url: 'https://hongtaovideo.com/category/news' },
          { name: article.title, url: `https://hongtaovideo.com/article/${article.id}` },
        ]}
      />
      <Navbar />
      <main className="pt-20 md:pt-24">
        <article className="w-full px-4 md:px-6 lg:px-10 py-8 md:py-12 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-400 mb-6">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line" />
              <Link to="/category/news" className="hover:text-primary-500 transition-colors cursor-pointer">资讯</Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-700 font-medium line-clamp-1">{article.title}</span>
            </nav>

            <div className="mb-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-2.5 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-md">
                  {article.category}
                </span>
                <span className="text-xs text-foreground-400">{article.date}</span>
              </div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4 leading-tight">
                {article.title}
              </h1>
            </div>

            <div className="relative h-64 md:h-80 rounded-xl overflow-hidden mb-8">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="prose prose-sm md:prose-base max-w-none">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                {article.summary}
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                红桃视频始终致力于为用户提供最优质的视频娱乐服务。作为国内领先的正版高清影视平台，
                我们不断优化内容生态，丰富影视资源库，确保每一位用户都能在这里找到心仪的内容。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                平台拥有超过10万小时的影视资源，涵盖电视剧、电影、综艺、动漫、纪录片等多个品类。
                无论是热门院线大片、经典剧集回顾，还是独家原创内容，红桃视频都能满足您的观影需求。
              </p>
              <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mt-8 mb-3">
                持续优化用户体验
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                在技术层面，红桃视频持续投入研发资源，优化播放引擎和推荐算法。
                我们的AI智能推荐系统基于深度学习技术，能够精准分析用户的观影偏好，
                为每位用户提供高度个性化的内容推荐，让发现好内容变得前所未有的简单。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                画面质量方面，红桃视频已全面支持4K HDR超清画质和杜比全景声技术。
                配合自适应码率技术，无论您的网络条件如何，系统都会自动匹配最佳画质，
                确保流畅稳定的观看体验。
              </p>
              <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mt-8 mb-3">
                正版承诺与社会责任
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                红桃视频坚持正版化运营理念，平台所有内容均已获得正规版权授权。
                我们与国内外数百家影视制作公司、发行方建立了长期稳定的合作关系，
                共同推动中国影视产业的健康发展。选择红桃视频，就是选择正版，支持优质内容创作。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                未来，红桃视频将继续深耕内容领域，加大原创内容投入，
                同时积极拓展海外市场，致力于成为具有国际影响力的视频娱乐平台。
                我们相信，通过不断的努力和创新，红桃视频将为您带来更多惊喜与感动。
              </p>
            </div>

            <div className="border-t border-background-200 mt-10 pt-8">
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-4">相关文章</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {relatedArticles.map((rel) => (
                  <Link
                    key={rel.id}
                    to={`/article/${rel.id}`}
                    className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-transform hover:-translate-y-1"
                  >
                    <div className="h-32 overflow-hidden">
                      <img src={rel.image} alt={rel.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                    </div>
                    <div className="p-3">
                      <p className="text-xs text-foreground-400 mb-1">{rel.date}</p>
                      <p className="text-xs font-medium text-foreground-800 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                        {rel.title}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}